import { render } from "./NoAccess.vue?vue&type=template&id=796d0026"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"
script.render = render

export default script